import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { first } from "rxjs/operators";

import { environment } from "src/environments/environment";

export type ImtPurpose = "own_permanent" | "own_secondary" | "other";
export type ImtRegion = "continent" | "autonomous";

export interface ImtProfile {
  price?: number | null;
  purpose?: ImtPurpose | null;
  region?: ImtRegion | null;
  youngBuyer?: boolean | null;
  taxableAssetValue?: number | null;
}

export interface ImtEstimate {
  taxableValue: number;
  imt: number;
  stampDuty: number;
  stampDutyExempt?: boolean;
  /** Jovem ≤35 em HPP entre os dois limites: IS só sobre o excesso. */
  stampDutyPartialExempt?: boolean;
  total: number;
  purpose: ImtPurpose;
  region: ImtRegion;
  youngBuyer: boolean;
  tableYear: number;
  isEstimate: true;
}

export interface ImtSimulation {
  estimate: ImtEstimate | null;
  inputs: {
    price: number | null;
    purpose: ImtPurpose;
    region: ImtRegion;
    youngBuyer: boolean;
    taxableAssetValue: number | null;
  };
  tableYear: number;
}

/** Simuladores soltos (modal da barra superior). As tabelas vivem no servidor. */
@Injectable({ providedIn: "root" })
export class SimulatorsService {
  constructor(private readonly http: HttpClient) {}

  simulateImt(profile: ImtProfile): Observable<ImtSimulation> {
    const body: any = {};
    const price = Number(profile?.price);
    if (Number.isFinite(price) && price > 0) body.price = price;
    if (profile?.purpose) body.purpose = profile.purpose;
    if (profile?.region) body.region = profile.region;
    body.youngBuyer = profile?.youngBuyer === true;
    const vpt = Number(profile?.taxableAssetValue);
    if (Number.isFinite(vpt) && vpt > 0) body.taxableAssetValue = vpt;

    return this.http
      .post<ImtSimulation>(`${environment.apiUrl}/simulators/imt`, body, {
        withCredentials: true,
      })
      .pipe(first());
  }
}
